import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { useSelector } from "react-redux";

export const initialState = {
  agentsWithPhoneUsage: [],
  trackingNumbers: [],
  twilioRecordingStartSoundUrl: null,
};

const updateRoutingNumber = createAsyncThunk("phoneSettings/updateRoutingNumber", ({ link }, thunkApi) =>
  caseTransformingAxios
    .patch(link, null, {
      maxRedirects: 0,
      signal: thunkApi.signal,
    })
    .then(({ data }) => data),
);

const updateUserRecordingSettings = createAsyncThunk(
  "phoneSettings/updateUserRecordingSettings",
  ({ userUuid, settings: callRecordingUserSettings }, thunkApi) =>
    caseTransformingAxios
      .post(
        `/api/v4/call_recording/user_settings/${userUuid}/upsert`,
        {
          callRecordingUserSettings,
        },
        { signal: thunkApi.signal },
      )
      .then(({ data }) => data),
);

export const phoneSettingsSlice = createSlice({
  name: "phoneSettings",
  initialState,
  reducers: {
    setCnamToAgent: (state, action) => {
      const agent = state.agentsWithPhoneUsage.find((agent) => agent.id === action.payload.userId);

      if (agent) {
        agent.twilioCnam = action.payload.twilioCnam;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateRoutingNumber.pending, (state, action) => {
        const agent = state.agentsWithPhoneUsage.find((agent) => agent.id === action.meta.arg.userId);
        if (agent) agent.loading = true;
      })
      .addCase(updateRoutingNumber.fulfilled, (state, action) => {
        const agent = state.agentsWithPhoneUsage.find((agent) => agent.id === action.meta.arg.userId);
        if (agent) {
          agent.loading = false;
          agent.routingNumberId = action.payload.routingNumberId;
        }
      })
      .addCase(updateRoutingNumber.rejected, (state, action) => {
        const agent = state.agentsWithPhoneUsage.find((agent) => agent.id === action.meta.arg.userId);
        if (agent) agent.loading = false;
      });

    builder
      .addCase(updateUserRecordingSettings.pending, (state, action) => {
        const agent = state.agentsWithPhoneUsage.find((agent) => agent.uuid === action.meta.arg.userUuid);
        if (agent) agent.loading = true;
      })
      .addCase(updateUserRecordingSettings.fulfilled, (state, action) => {
        const agent = state.agentsWithPhoneUsage.find((agent) => agent.uuid === action.meta.arg.userUuid);
        if (agent) {
          agent.loading = false;
          agent.callRecordingSettings = action.payload;
        }
      })
      .addCase(updateUserRecordingSettings.rejected, (state, action) => {
        const agent = state.agentsWithPhoneUsage.find((agent) => agent.uuid === action.meta.arg.userUuid);
        if (agent) agent.loading = false;
      });
  },
});

export { updateRoutingNumber, updateUserRecordingSettings };

export default phoneSettingsSlice.reducer;

export const { setCnamToAgent } = phoneSettingsSlice.actions;

export const useAgentsWithPhoneUsage = () => useSelector((state) => state.phoneSettings.agentsWithPhoneUsage);
